"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVirtualGameTokenSaga = getVirtualGameTokenSaga;
exports.virtualGamesProviderSaga = virtualGamesProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../LanguagesProvider/selectors");
const logger_1 = require("../../utils/logger");
const api_1 = require("../../api/virtual-games/api");
const slice_1 = require("./slice");
function* getVirtualGameTokenSaga(action) {
    try {
        const languageCode = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { accountId, gameVendor } = action.payload;
        if (gameVendor === betweb_openapi_axios_1.VirtualGameVendor.Unknown) {
            (0, logger_1.logger)(`Got unknown vendor ${gameVendor}. Cant get token`);
            return;
        }
        const { data: token, } = yield (0, effects_1.call)(gameVendor === betweb_openapi_axios_1.VirtualGameVendor.BetGames
            ? api_1.createBetGamesToken
            : api_1.createVirtualGamesToken, {
            newVirtualGamesToken: {
                accountId,
                gameVendor,
                languageCode,
            },
        });
        yield (0, effects_1.put)(slice_1.virtualGamesProviderActions.getTokenSuccess({ gameVendor, token }));
    }
    catch (error) {
        const { gameVendor } = action.payload;
        console.error(`Error occurred while fetching ${gameVendor} token`);
        yield (0, effects_1.put)(slice_1.virtualGamesProviderActions.getTokenError({
            gameVendor,
            error,
        }));
    }
}
function* virtualGamesProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeEvery)(slice_1.virtualGamesProviderActions.getToken.type, getVirtualGameTokenSaga),
    ]);
}
//# sourceMappingURL=saga.js.map